import { USER_ROLES } from 'constants/constants';
import axiosClient from './axiosClient';

const userGroupApi = {
  get: (params) => {
    const url = '/course-groups';
    return axiosClient.get(url, { params });
  },
  getById: (id) => {
    const url = `/course-groups/${id}`;
    return axiosClient.get(url);
  },
  create: (data) => {
    const url = '/course-groups';
    return axiosClient.post(url, data);
  },
  edit: (id, data) => {
    const url = `/course-groups/${id}`;
    return axiosClient.put(url, data);
  },
  delete: (id) => {
    const url = `/course-groups/${id}`;
    return axiosClient.delete(url);
  },
  addUserToGroup: (data) => {
    const url = '/user-course-groups';
    return axiosClient.post(url, data);
  },
  updateUserToGroup: (id, data) => {
    const url = `/user-course-groups/${id}`;
    return axiosClient.put(url, data);
  },
  deleteUserToGroup: (id) => {
    const url = `/user-course-groups/${id}`;
    return axiosClient.delete(url);
  },
  getTestAndAssignments: (id) => {
    const url = `/groups/get-test-assignments-by-course/${id}`;

    return axiosClient.get(url);
  },
  getTestAndAssignmentWithIntake: (id) => {
    const url = `/groups/get-test-assignments-by-intake/${id}`;
    return axiosClient.get(url);
  },
  getTestAndAssignmentsSummary: (id, type) => {
    const url = `/courses/${id}/summaries?type=test `;

    return axiosClient.get(url);
  },
  getClassroomService: (id, type) => {
    const url = `/groups/get-live-classrooms-by-course/${id}?type=${type}`;
    return axiosClient.get(url);
  },

  getClassRoomByIntake: (id) => {
    const url = `/groups/get-live-classrooms-by-intake/${id}`;
    return axiosClient.get(url);
  },

  addNewGroup: (data) => {
    const url = `/groups`;
    return axiosClient.post(url, data);
  },
  getIntake: (id, param) => {
    const url = `/courses/${id}/get-intake`;
    return axiosClient.get(url, param);
  },
  getGroupbyIntakeId: (id) => {
    const url = `/groups/get-intake-groups/${id}/`;
    return axiosClient.get(url);
  },
  addNewIntakes: (data) => {
    const url = `/course-units`;
    return axiosClient.post(url, data);
  },
  getUnit: (groupid) => {
    const url = `/course-units/get-group-units/${groupid}`;
    return axiosClient.get(url);
  },
  getCourseSummaries: (id, param) => {
    const url = `/courses/${id}/summaries`;
    return axiosClient.get(url, param);
  },
  getintakeSummaries: (id, param) => {
    const url = `/courses/intake/${id}/summaries`;
    return axiosClient.get(url, param);
  },
  getIntakeContentPage: (id) => {
    const url = `/groups/get-intake-summaries/${id}`;
    return axiosClient.get(url);
  },
  getCourseContentPage: (id) => {
    const url = `/groups/get-summaries/${id}`;
    return axiosClient.get(url);
  },
  getTest: (id, type) => {
    const url = `/groups/get-tests-by-course/${id}?type=${type}`;
    return axiosClient.get(url);
  },
  getAssignment: (id, type) => {
    const url = `/groups/get-assignments-by-course/${id}?type=${type}`;

    return axiosClient.get(url);
  },
  getTestAssignmentClass: (params) => {
    const url = `/user-courses/get-units?`;
    return axiosClient.get(url, { params });
  },
  getAllLessonByIntake: (id, params) => {
    const url = `/user-courses/get-course-units?id=${id}`;
    return axiosClient.get(url, { params });
  },

  /**
   *
   * @param {{intake: string, courseCentre?: string}} params
   * @returns {Promise<{data: {email: string, _id: string, type: {defaultRole: keyof USER_ROLES}}[], totalItems: number}>}
   */
  getIntakeByLessons: (params) => {
    const url = `/courses/get-users-by-intake`;
    return axiosClient.get(url, { params });
  },
};

export default userGroupApi;
